import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { PortalOneColumnLayout } from 'components/PortalStructure';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { ILanguage } from 'models/common';
import { IUserLanguage } from 'models/user/userlanguage';
import { browserHistory } from 'react-router';
import { Button } from '../../Common/Button';
require('./style.css');

interface IProps {
	languageDomainValues?: ILanguage[];
	userLanguage?: IUserLanguage;

	/* func props */
	t?: (key: string) => string;
}

@connect(
	(state: IStore) => ({
		languageDomainValues: state.domainValues.languages,
		userLanguage: state.userLanguage,
	}),
	(dispatch) => ({
		dispatch,
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class EmailConfirmedMessage extends React.Component<IProps, any> {
	public redirectHome(e) {
		if (e) {
			e.preventDefault();
		}
		const culture = this.props.userLanguage.culture;

		if (culture) {
			browserHistory.push('/home/' + culture.substring(0, 2));
		}
	}

	public render() {
		const { t } = this.props;
		return (
			<PortalOneColumnLayout>
				<div className="emailConfirmedMessage">
					<div className="insideWrapper">
						<img src={require('containers/Html/images/email-confirmed.png')} />
						<h1>{t('EmailConfirmedMessage_Title')} </h1>
						<h2>{t('EmailConfirmedMessage_ThankYou')} </h2>
						<Button onClick={(e) => this.redirectHome(e)}>
							{t('EmailConfirmation_EmailConfirmedMessage_Button_GetStarted')}
						</Button>
					</div>
				</div>
			</PortalOneColumnLayout>
		);
	}
}

export { EmailConfirmedMessage };
